import React, { useState } from 'react';
import { Card, Collapse, Button, Modal } from 'react-bootstrap';
import { BiInfoCircle, BiChevronUp, BiChevronRight, BiPlus } from 'react-icons/bi';
import { Link } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { useCookies } from 'react-cookie';
import { useGetQuery } from '../Utils/api';
import ActiviteTypesDetails from './ActiviteTypesDetails';

interface InfoCardProps {
    defaultOpen?: boolean;
}

const InfoCard: React.FC<InfoCardProps> = ({ defaultOpen = true }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [cookies, setCookie] = useCookies(['hideInstructions']);
    const hideInstructions = Boolean(JSON.parse(cookies.hideInstructions ?? 'false'));
    const [open, setOpen] = useState(defaultOpen);
    const handleOpen = (event: React.SyntheticEvent) => {
        event.preventDefault();
        setOpen(!open);
    };
    const jaiCompris = () => {
        setOpen(hideInstructions);
        setCookie('hideInstructions', !hideInstructions, { maxAge: 60 * 60 * 24 * 365 * 10 });
    };
    const { data: nbTotalActivites } = useGetQuery<number>(['activites', 'count']);

    return (
        <Card style={{ zIndex: 1 }}>
            <Card.Header className="alert-info position-relative">
                <Card.Title className="mb-0 d-flex">
                    <span>
                        <BiInfoCircle className="mb-1" /> Comment utiliser le site?
                    </span>
                    <BiChevronUp
                        size="1.5em"
                        className="ml-auto"
                        style={{
                            transform: `rotate(${open ? 0 : '180deg'})`,
                            transition: 'transform 0.3s',
                        }}
                    />
                </Card.Title>
                <a href="#" className="stretched-link" onClick={(e) => handleOpen(e)}></a>
            </Card.Header>
            <Collapse in={open}>
                <div>
                    <Card.Body>
                        <div className="d-flex">
                            <div className="mr-2">
                                <h5 className="text-display">1.</h5>
                            </div>
                            <div className="flex-grow-1 pb-3">
                                <h5>Consultez la liste des activités</h5>
                                <p className="mb-1">
                                    <b>{nbTotalActivites} activités</b> sont disponibles et de nouvelles activités sont
                                    ajoutées chaque année.{' '}
                                    <Link to="/activites" className="text-nowrap">
                                        Voir toutes les activités
                                        <BiChevronRight size="1.25em" />
                                    </Link>
                                </p>
                                <p className="mb-1">
                                    Les activités sont séparées en <b>4 types</b> : Entrée, Sortie, Livraison et En
                                    Ligne.{' '}
                                    <a href="#" onClick={handleShow} className="text-nowrap">
                                        En savoir plus sur les types d'activité
                                        <BiChevronRight size="1.25em" />
                                    </a>{' '}
                                </p>

                                <Modal show={show} onHide={handleClose} size="xl">
                                    <Modal.Header closeButton className="alert-info">
                                        <Modal.Title>
                                            <BiInfoCircle className="mb-1" /> Détails sur les types d'activité
                                        </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <ActiviteTypesDetails />
                                    </Modal.Body>
                                </Modal>
                            </div>
                        </div>
                        <div className="d-flex">
                            <div className="mr-2">
                                <h5>2.</h5>
                            </div>
                            <div className="flex-grow-1 pb-3">
                                <h5>Réservez des activités</h5>
                                <p className="mb-0">
                                    Cliquez sur une activité pour avoir tous les détails à son sujet. Si l'activité vous
                                    plait, ajoutez-la à votre réservation en cliquant sur le bouton bleu{' '}
                                    <LinkContainer to="/reservation">
                                        <Button size="sm">Activité</Button>
                                    </LinkContainer>{' '}
                                    {/**ou{' '}
                                  <LinkContainer to="/reservation">
                                        <Button size="sm" className="px-1">
                                            <BiPlus size="1.5em" />
                                        </Button>
                                    </LinkContainer>**/}
                                    .
                                </p>
                                <p className="mb-1">
                                    La liste des activités choisies est accesible en tout temps via l'onglet Réserver.{' '}
                                    <Link to="/reservation" className="text-nowrap">
                                        Voir mes réservations
                                        <BiChevronRight size="1.25em" />
                                    </Link>
                                </p>
                                <p className="mb-1">
                                    Il est aussi possible d'ajouter une réservation d'autobus pour une sortie.{' '}
                                    <Link to="/transport" className="text-nowrap">
                                        En savoir plus sur la réservation de transport
                                        <BiChevronRight size="1.25em" />
                                    </Link>
                                </p>
                            </div>
                        </div>
                        <div className="d-flex">
                            <a className="btn btn-outline-primary ml-auto" href="#" onClick={jaiCompris}>
                                {hideInstructions
                                    ? 'Toujours afficher ce message'
                                    : "J'ai compris, ne plus afficher ce message"}
                            </a>
                        </div>
                    </Card.Body>
                </div>
            </Collapse>
        </Card>
    );
};

export default InfoCard;
